import React from 'react'

const AddedStoreBranchCard = () => {
  return (
    <div>AddedStoreBranchCard</div>
  )
}

export default AddedStoreBranchCard